import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MentionsInput, Mention } from 'react-mentions';
import Avatar from '@strava/ui/Avatar';

// to do: MentionableCommentForm and MentionableComments need to be refactored.
// in the future it may be helpful to refactor these files, as well as defaultStyle
// so that they could live in one shared location
//
// TODO: [update] - this component can be updated to use StravaMentionsInput directly.
// once this is done its current unit tests can also be potentially removed since they are
// covered in StravaMentionsInput.test.
//
// QA tests similar to cypress/integration/mentionable_comments_form.spec.js can then be used to
// test mentionable athletes functionality on the activity details page.
import styles from './index.scss';
import { fetchAthletes } from '../StravaMentionsInput/StravaMentionsInput.cache';
import { setMentionInputStyles } from '../StravaMentionsInput/MentionInputStyles';
import { sortAndFilter } from '../StravaMentionsInput/StravaMentionsInput.utils';

const mentionsStyle = setMentionInputStyles({ inputHeight: 108 });

function ActivityDescriptionEdit({
  entity,
  entityId,
  placeHolder,
  activityDescription,
  suggestionLimit,
  autoFocus,
  viewingAthleteId,
  inputName
}) {
  const [mentionableAthletes, setMentionableAthletes] = useState([]);
  const [description, setDescription] = useState(activityDescription);

  useEffect(() => {
    fetchAthletes({ viewingAthleteId }).then((mentionableFollowers) => {
      setMentionableAthletes(mentionableFollowers);
    });
  }, [entity, entityId, viewingAthleteId]);

  const handleChange = (_, value) => {
    setDescription(value);
  };

  const nameFromId = (id) => {
    if (mentionableAthletes && mentionableAthletes.length > 0) {
      return mentionableAthletes.find((a) => a.id === parseInt(id, 10)).display;
    }
    return '';
  };

  const filteredMentionableAthletes = (query) => {
    const results = mentionableAthletes.filter(
      (a) => a.display.toLowerCase().indexOf(query.toLowerCase()) >= 0
    );
    return results.slice(0, suggestionLimit);
  };

  const fetchEntityAthletes = (e) => {
    if (entityId) {
      if (e.key === '@') {
        fetchAthletes({
          entity,
          entityId,
          viewingAthleteId
        }).then((mentionableEntityOwners) => {
          const filtered = sortAndFilter(
            mentionableAthletes.concat(mentionableEntityOwners),
            viewingAthleteId
          );
          setMentionableAthletes(filtered);
        });
      }
    }
  };

  const renderSuggestion = (entry) => {
    const avatarStyle = { marginRight: '8px' };
    return (
      <div className={styles.suggestion} data-testid="suggestions">
        <Avatar
          name={entry.display}
          src={entry.profile}
          size="small"
          type="athlete"
          style={avatarStyle}
          badge={entry.member_type}
        />
        <div>
          <div className={styles.athleteName}>{entry.display}</div>
          {entry.location && entry.location.length > 0 && (
            <div className={`text-caption2 ${styles.location}`}>
              {entry.location}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <MentionsInput
        allowSpaceInQuery={true}
        autoFocus={autoFocus}
        value={description || ''}
        placeholder={placeHolder}
        onChange={handleChange}
        onKeyDown={fetchEntityAthletes}
        classNames={styles}
        style={mentionsStyle}
      >
        <Mention
          appendSpaceOnAdd={true}
          data={filteredMentionableAthletes}
          displayTransform={nameFromId}
          markup="[strava://athletes/__id__]"
          renderSuggestion={renderSuggestion}
          className={styles.mentionedAthlete}
          style={mentionsStyle}
        />
      </MentionsInput>
      <input name={inputName} type="hidden" value={description || ''} />
    </div>
  );
}

ActivityDescriptionEdit.propTypes = {
  entity: PropTypes.string.isRequired,
  entityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeHolder: PropTypes.string,
  activityDescription: PropTypes.string,
  suggestionLimit: PropTypes.number,
  autoFocus: PropTypes.bool,
  viewingAthleteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  inputName: PropTypes.string.isRequired
};

ActivityDescriptionEdit.defaultProps = {
  placeHolder: null,
  suggestionLimit: 5,
  entityId: null,
  activityDescription: '',
  autoFocus: false
};

export default ActivityDescriptionEdit;
